import { call, select } from 'redux-saga/effects';
import { requestUapiPlantingEvents } from '../../requesters/plantingRequester/uapiPlantingRequester';
import { requestPlantingEvents } from '../../requesters/plantingRequester';
import { getPlantingArdDataFeatureSelector } from '../../selectors/featureSelectors';
import { StoreCrops } from '../../types/Crop';

export interface RetrievePlantingDataParams {
  fieldUUID: string;
  cropsMap: StoreCrops
}

export function* retrievePlantingData({ fieldUUID, cropsMap}: RetrievePlantingDataParams) {
  const isPlantingArdDataEnabled = yield select(getPlantingArdDataFeatureSelector);
  if (isPlantingArdDataEnabled) {
    return yield call(requestUapiPlantingEvents, fieldUUID, cropsMap);
  } 
  
  return yield call(requestPlantingEvents, fieldUUID);
}
